import { Error } from "common/Error";

export const Notifications = () => {
  return <Error />;
};
